// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".X1fM9mVPv980TEbu2YVjkw\\=\\={padding:10px 30px 10px 10px}", "",{"version":3,"sources":["webpack://./resources/js/ChatBot/embedded/components/LoadingChatBotResponseText/LoadingChatBotResponseText.module.scss"],"names":[],"mappings":"AAAA,4BACI,2BACJ","sourcesContent":[".chatItemHolder {\r\n    padding: 10px 30px 10px 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chatItemHolder": "X1fM9mVPv980TEbu2YVjkw=="
};
export default ___CSS_LOADER_EXPORT___;
